import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { CheckCircle, FormatListBulleted, AccessTime, TrendingUp, CalendarToday, Assessment } from '@mui/icons-material';
import { InfoItem } from './shared';
import { formatPromptingLevel } from './utils';
import { getCriteriaVariableLabel } from '../../../pages/ViewGoal/Insights/Criteria/utils/criteriaUtils';

const MeasurementTab = ({ goalData }) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Paper variant='outlined' sx={{ p: 4, bgcolor: '#f8f9ff', borderRadius: '16px', border: '1px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <CheckCircle fontSize='medium' color='action' />
            <Typography variant='h5' sx={{ fontWeight: 600, color: '#2c3e50' }}>
              Goal Target
            </Typography>
          </Box>
          <Typography variant='body1' sx={{ color: '#2c3e50', lineHeight: 1.8, fontSize: '1.1rem' }}>
            {goalData?.DataCollection?.measurementType?.Target === 'Atmost' ? 'At most' :
             goalData?.DataCollection?.measurementType?.Target === 'Atleast' ? 'At least' :
             goalData?.DataCollection?.measurementType?.Target}{' '}
            <Box component='span' sx={{ fontWeight: 'bold', color: '#9291ef' }}>
              {goalData?.DataCollection?.measurementType?.TargetDuration}{' '}
            </Box>
            {goalData?.DataCollection?.measurementType?.ConsecutiveTargetDuration && 'consecutive '}
            {goalData?.DataCollection?.measurementType?.Type === 'Frequency' && 'times'}
            {goalData?.DataCollection?.measurementType?.Type === 'Duration' && 'mins'}
            {goalData?.DataCollection?.measurementType?.Type === 'Percentage' && '%'}
            {goalData?.DataCollection?.measurementType?.DataType}
            {goalData?.DataCollection?.measurementType?.Type === 'Prompting' && goalData?.DataCollection?.measurementType?.PromptingLevel && (
              <>
                {' with '}
                <Box component='span' sx={{ fontWeight: 'bold', color: '#9291ef' }}>
                  {formatPromptingLevel(goalData?.DataCollection?.measurementType?.PromptingLevel)}
                </Box>{' '}
              </>
            )}
            {goalData?.DataCollection?.measurementType?.Type === 'Trials' &&
              ` in ${goalData?.DataCollection?.measurementType?.TrailsValue?.TrailsMin} ${goalData?.DataCollection?.measurementType?.ConsecutiveTrialDuration ? 'consecutive trials' : 'trials'} out of ${goalData?.DataCollection?.measurementType?.TrailsValue?.TrailsMax} trials`}
            .
          </Typography>
        </Paper>
      </Grid>

      {goalData?.DataCollection?.measurementType?.Criteria?.length > 0 && (
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <FormatListBulleted fontSize='medium' color='action' />
            <Typography variant='h5' sx={{ fontWeight: 600, color: '#2c3e50' }}>
              Additional Criteria
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {goalData?.DataCollection?.measurementType?.Criteria?.map((criteria, index) => (
              <Paper key={index} variant='outlined' sx={{ p: 3, backgroundColor: '#f8f9ff', borderRadius: '12px', border: '1px solid #e0e0e0' }}>
                <Typography variant='body1' sx={{ fontSize: '1.1rem', lineHeight: 1.6 }}>
                  {criteria.Target === 'Atmost' ? 'At most' : criteria.Target === 'Atleast' ? 'At least' : criteria.Target}{' '}
                  <Box component='span' sx={{ fontWeight: 'bold', color: '#9291ef' }}>
                    {criteria.TargetDuration}{' '}
                  </Box>
                  {criteria?.Consecutive && 'consecutive '}
                  {criteria?.MeasurementType === 'Frequency' && 'times of '}
                  {criteria?.MeasurementType === 'Duration' && 'mins of '}
                  {criteria?.MeasurementType === 'Percentage' && '% of '}
                  <Box component='span' sx={{ fontWeight: 'bold', color: '#2c3e50' }}>
                    {getCriteriaVariableLabel(criteria)}
                  </Box>
                </Typography>
              </Paper>
            ))}
          </Box>
        </Grid>
      )}

      {goalData?.DataCollection?.MultipleDataPointsPerSession?.MultipleDataPointsPerSession === 'Yes' && (
        <InfoItem icon={<Assessment fontSize='small' color='action' />} label='What to do with multiple data points?' value={goalData?.DataCollection?.MultipleDataPointsPerSession?.DataPointPerSession} xs={12} sm={4} />
      )}

      {goalData?.DataCollection?.MultipleTimesToMeetGoal?.MultipleTimesToMeetGoal && (
        <InfoItem icon={<AccessTime fontSize='small' color='action' />} label='Does the goal have to be met multiple times?' value={goalData?.DataCollection?.MultipleTimesToMeetGoal?.MultipleTimesToMeetGoal} xs={12} sm={4} />
      )}

      {goalData?.DataCollection?.MultipleTimesToMeetGoal?.MultipleTimesToMeetGoal === 'Yes' && (
        <>
          {goalData?.DataCollection?.MultipleTimesToMeetGoal?.NumberOfSessions && (
            <InfoItem icon={<TrendingUp fontSize='small' color='action' />} label='Number of times sessions the goal must be met?' value={goalData?.DataCollection?.MultipleTimesToMeetGoal?.NumberOfSessions} xs={12} sm={4} />
          )}
          {goalData?.DataCollection?.MultipleTimesToMeetGoal?.ConsecutiveSessions && (
            <InfoItem icon={<CalendarToday fontSize='small' color='action' />} label='Do the sessions have to be consecutive?' value={goalData?.DataCollection?.MultipleTimesToMeetGoal?.ConsecutiveSessions} xs={12} sm={4} />
          )}
        </>
      )}
    </Grid>
  );
};

export default MeasurementTab;


